import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBolt } from '@fortawesome/pro-solid-svg-icons/faBolt';

import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { Text, TextType } from 'ui-components/components/text';
import { Button } from 'ui-components/components/button';
import DataDrivenLogo from '../../../components/data-driven-logo';
import styles from './inventory-sync-page.module.less';
import { pages } from '../nav-items';
import { MarketplaceIds } from '../../../enums/marketplace-ids';
import messages from './messages';

/**
 * SyncTargetSetupGuide component.
 * @param {object} props - Component props.
 * @param {boolean} props.inventorySyncFeatureEnabled - Indicates if the inventory sync feature is enabled.
 * @param {boolean} props.isEditing - Indicates if the user is editing the inventory sync setup.
 * @returns {JSX.Element} The rendered component.
 */
const InventorySyncSetupPanel = ({ inventorySyncFeatureEnabled, isEditing }) => {
  const history = useHistory();

  const onClickGetInventorySyncButton = useCallback(() => {
    history.push(`./${pages.addOnMarketplace.location}`);
  }, [history]);

  let descriptionMessage;
  if (inventorySyncFeatureEnabled) {
    descriptionMessage = isEditing ? messages.describeSettingUpTargetsToSyncLabel : messages.describeChoosingTargetLabel;
  } else {
    descriptionMessage = messages.getInventorySyncDescriptionText;
  }
  const getInventorySyncDescriptionText = descriptionMessage;

  return (
    <div className={styles['initial-state-container']}>
      {!inventorySyncFeatureEnabled && (
        <Button className={styles['initial-state-button']} onClick={onClickGetInventorySyncButton} theme='promotional'>
          <FontAwesomeIcon className={styles['button-icon']} icon={faBolt} />
          <Text textType={TextType.Label} value={messages.getInventorySyncButtonLabel} />
        </Button>
      )}
      <Text className={styles['get-inventory-sync-descriptive-text']} textType={TextType.Caption} value={getInventorySyncDescriptionText} />
      {isEditing && (
        <div className={styles['sync-marketplace-container']}>
          <div className={styles['sync-marketplace-icon']}>
            <DataDrivenLogo logoType='icon' marketplaceId={MarketplaceIds.Shopify} />
          </div>
          <div className={styles['sync-marketplace-icon']}>
            <DataDrivenLogo logoType='icon' marketplaceId={MarketplaceIds.Squarespace} />
          </div>
          <div className={styles['sync-marketplace-icon']}>
            <DataDrivenLogo logoType='icon' marketplaceId={MarketplaceIds.BigCommerce} />
          </div>
          <div className={styles['sync-marketplace-icon']}>
            <DataDrivenLogo logoType='icon' marketplaceId={MarketplaceIds.Amazon} />
          </div>
        </div>
      )}
    </div>
  );
};

export default InventorySyncSetupPanel;
